import React from 'react';
import { ArrowDownIcon } from '../../../components/icons/ArrowDownIcon';
import { ArrowUpIcon } from '../../../components/icons/ArrowUpIcon';
import { formatNumberWithPrecision } from '../../../utils/number';

type PercentageChangeProps = {
  oldValue: number;
  newValue: number;
};

export const PercentageChange: React.FC<PercentageChangeProps> = ({ oldValue, newValue }) => {
  const percentageDifference = getPercentageDifference(oldValue, newValue);
  const formattedPercentageDifference = formatNumberWithPrecision(Math.abs(percentageDifference), 1);

  return (
    <div className="flex items-center justify-center gap-2">
      <div>{percentageDifference !== 0 ? `${formattedPercentageDifference}%` : '0%'}</div>
      <div>
        {percentageDifference !== 0 ? percentageDifference < 0 ? <ArrowDownIcon /> : <ArrowUpIcon /> : <></>}
      </div>
    </div>
  );
};

function getPercentageDifference(oldValue: number, newValue: number) {
  if (oldValue === 0 && newValue === 0) {
    return 0;
  }

  if (oldValue === 0) {
    return 100;
  }

  return ((newValue - oldValue) / oldValue) * 100;
}
